import { createSlice, PayloadAction } from "@reduxjs/toolkit";


const initialState: any = {
  data: null,
};

const TreeViewSlice = createSlice({
  name: "treeViewData",
  initialState,
  reducers: {
    setData: (state, action: PayloadAction<any>) => {
      state.data = action.payload;
    },
  },
});

export const { setData } = TreeViewSlice.actions;
export default TreeViewSlice.reducer;
